module.exports = __webpack_public_path__ + "static/media/corretora-img.ce5ad46c.png";